export const TYPE_ITEMS = ['YouTube','Link 360','TikTok','Outros']
